import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-node-configurator',
  templateUrl: './delete-node-configurator.component.html',
  styleUrls: ['./delete-node-configurator.component.scss']
})
export class DeleteNodeConfiguratorComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<DeleteNodeConfiguratorComponent>
  ) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialog.close(false);
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    let confirm: boolean = true;
    this.dialog.close(confirm);
  }

}
